/** Nature Club の LP (Figma Sites)。webapp のグロナビ・拠点ページと、しおりメールから遷移する */
export const NATURE_CLUB_LP_URL = "https://natureclub.sa-nu.com";
